/* eslint-disable */

<template>
  <div class="vx-row Lgx202142297964412928">
    <div class="vx-col w-full">
      <vx-card class="mb-3">
        <div class="flex items-center justify-between">
          <vs-button class="shadow-lg" color="success" icon="icon-arrow-right" icon-pack="feather" icon-after
                     v-if="currentPage === 0" @click="changePage('next')">Next Page
          </vs-button>
          <vs-button class="shadow-lg mr-2" color="danger" icon="icon-arrow-left" icon-pack="feather"
                     v-else @click="changePage('previous')">Previous Page
          </vs-button>
          <p class="ml-4">Page: {{ currentPage + 1 }} / 2</p>
        </div>
      </vx-card>
      <vx-card class="mb-8">
        <div class="fourth-sim pt-0">
          <div class="vx-row mb-4">
            <div class="vx-col w-4/12 flex items-center">
              <h2 class="font-bold">Cyber Attack Overview</h2>
            </div>
            <div class="vx-col w-2/12 flex items-center">
              <h2 class="font-bold">Potential Target</h2>
            </div>
            <div class="vx-col w-3/12 flex items-center">
              <h2 class="font-bold">Type of Attack</h2>
            </div>
            <div class="vx-col w-3/12 flex items-center">
              <h2 class="font-bold">Attack Remediation</h2>
            </div>
          </div>
          <div class="vx-row items-center border-white border-2 border-solid rounded p-2 my-4" v-for="item in currentPage === 0 ? table_items : table_items_p2" :key="item.id">
            <div class="vx-col w-4/12 flex items-center p-3">
              <h4 class="pr-24">{{ item.description }}</h4>
            </div>
            <div class="vx-col w-2/12 p-3">
              <h4> {{ item.target}} </h4>
            </div>
            <div class="vx-col w-3/12 p-3">
              <v-select placeholder="Select an attack from the dropdown" class="w-full" :options="attack_options" v-model="item.attack_selected" />
              <small v-if="item.attack_is_correct !== null && item.attack_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.attack_is_correct !== null && item.attack_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
            <div class="vx-col w-3/12 p-3">
              <v-select placeholder="Select an action from the dropdown" class="w-full" :options="action_options" v-model="item.action_selected"/>
              <small v-if="item.action_is_correct !== null && item.action_is_correct === false" class="ml-1 text-danger font-semibold">This answer is
                invalid</small>
              <small v-if="item.action_is_correct !== null && item.action_is_correct === true" class="ml-1 text-success font-semibold">This answer is
                correct</small>
            </div>
          </div>
        </div>
      </vx-card>




    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {

      dataLocal: JSON.parse(JSON.stringify(this.data)),

      currentPage: 0,

      update_index: 0,

      table_items: [
        {
          id: 1,
          description: 'Hacker is injecting malicious java script in a vulnerable web server and wants to steal cookies from your machine.',
          target: 'Web Server',
          attack_selected: null,
          action_selected: null,
          attack_correct: 1,
          action_correct: 1,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 2,
          description: 'Attacker is changing the DNS entries to redirect you from a legitimate URL to a fake URL',
          target: 'DNS Server',
          attack_selected: null,
          action_selected: null,
          attack_correct: 2,
          action_correct: 2,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 3,
          description: 'A hacker is sending thousands of SYN Packets from multiple random sources',
          target: 'Web Server',
          attack_selected: null,
          action_selected: null,
          attack_correct: 3,
          action_correct: 3,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 4,
          description: 'This attack involves using IP spoofing and the ICMP to saturate a target network with traffic.',
          target: 'Network Router',
          attack_selected: null,
          action_selected: null,
          attack_correct: 4,
          action_correct: 4,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 5,
          description: 'Attacker uses IP packets to ping a target system with an IP size over the maximum of 65,535 bytes.',
          target: 'Remote Server',
          attack_selected: null,
          action_selected: null,
          attack_correct: 5,
          action_correct: 5,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 6,
          description: 'The hacker remotely establishes a connection that permits him to execute remote commands from his machine. ',
          target: 'End User',
          attack_selected: null,
          action_selected: null,
          attack_correct: 6,
          action_correct: 6,
          attack_is_correct: null,
          action_is_correct: null
        }
      ],
      table_items_p2: [
        {
          id: 7,
          description: 'An attacker intercepts and saves old messages and then tries to send them later, impersonating one of the participants.',
          target: 'Receiver',
          attack_selected: null,
          action_selected: null,
          attack_correct: 7,
          action_correct: 7,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 8,
          description: 'It is a self-propagating attack, does not require a host, targets a SQL database and is also looking to exploit default credentials of the database server.',
          target: 'MySQL Database Server',
          attack_selected: null,
          action_selected: null,
          attack_correct: 8,
          action_correct: 8,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 9,
          description: 'Attacker takes the time to conduct research into targets and creates email messages that are personal and relevant. ',
          target: 'Targeted end user',
          attack_selected: null,
          action_selected: null,
          attack_correct: 9,
          action_correct: 9,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 10,
          description: 'The hacker is targeting C-level exec with a hardware device to monitor the input activity and capture the login credentials',
          target: 'C-Level Executive',
          attack_selected: null,
          action_selected: null,
          attack_correct: 10,
          action_correct: 10,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 11,
          description: 'Hackers look for insecure websites and plant a malicious script into HTTP or PHP code on one of the pages. ',
          target: 'Target Users',
          attack_selected: null,
          action_selected: null,
          attack_correct: 11,
          action_correct: 11,
          attack_is_correct: null,
          action_is_correct: null
        },
        {
          id: 12,
          description: 'Hacker is inserting hidden access in a software application which is designed to skip account login',
          target: 'Target Application',
          attack_selected: null,
          action_selected: null,
          attack_correct: 12,
          action_correct: 12,
          attack_is_correct: null,
          action_is_correct: null
        }
      ],

      attack_options: [
        {id: 1, label: 'Cross Site Scripting (XSS)'},
        {id: 2, label: 'DNS Poisoning'},
        {id: 3, label: 'Botnet'},
        {id: 4, label: 'Smurf Attack'},
        {id: 5, label: 'Ping of Death'},
        {id: 6, label: 'RAT'},
        {id: 7, label: 'Session Replay Attack'},
        {id: 8, label: 'Worm'},
        {id: 9, label: 'Spear Phishing'},
        {id: 10, label: 'Keylogger'},
        {id: 11, label: 'Watering Hole Attacks'},
        {id: 12, label: 'Backdoor'}
      ],

      action_options: [
        {id: 1, label: 'Enable Input Validation'},
        {id: 2, label: 'Use DNSSEC for DNS Integrity'},
        {id: 3, label: 'Activate DDoS Protection'},
        {id: 4, label: 'Disable IP-directed broadcasts at the routers'},
        {id: 5, label: 'Use a firewall to check fragmented IP packets for maximum size.'},
        {id: 6, label: 'Disable Remote Access Services on the System'},
        {id: 7, label: 'Use session timestamps or nonce (a random number or a string that changes with time).'},
        {id: 8, label: 'Change the default application passwords on the SQL database.'},
        {id: 9, label: 'Analyze email headers to look for email spoofing.'},
        {id: 10, label: 'Activate 2FA or MFA and use push alert using OTP'},
        {id: 11, label: 'Use Input Validation'},
        {id: 12, label: 'Execute a code review on the application server.'}
      ]


    }
  },
  methods: {
    changePage (val) {
      if (val === 'next') {
        this.currentPage++
      }
      if (val === 'previous') {
        this.currentPage--
      }
    },
    markSimulation () {

      let total_score = 0

      this.table_items.forEach((x, i) => {
        if (x.attack_selected && x.attack_selected.id === x.attack_correct) {
          this.table_items[i].attack_is_correct = true
          total_score++
        } else {
          this.table_items[i].attack_is_correct = false
        }
        if (x.action_selected && x.action_selected.id === x.action_correct) {
          total_score++
          this.table_items[i].action_is_correct = true
        } else {
          this.table_items[i].action_is_correct = false
        }
      })

      this.table_items_p2.forEach((x, i) => {
        if (x.attack_selected && x.attack_selected.id === x.attack_correct) {
          this.table_items_p2[i].attack_is_correct = true
          total_score++
        } else {
          this.table_items_p2[i].attack_is_correct = false
        }
        if (x.action_selected && x.action_selected.id === x.action_correct) {
          total_score++
          this.table_items_p2[i].action_is_correct = true
        } else {
          this.table_items_p2[i].action_is_correct = false
        }
      })

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    Prism,
    vSelect,
    shuffle
  },
  created() {
    this.attack_options = shuffle(this.attack_options)
    this.action_options = shuffle(this.action_options)
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
<style>

.Lgx202142297964412928 {

  font-size: 19px;

}

</style>
